/** Shared pre-React copy; embedded pages cannot render their own errors before the entry module loads. */
export const shopifyAppLoadingCopy = {
    loading: 'Loading TestFeed',
    failed: 'TestFeed couldn’t load',
    retryHelp: 'Reload this page to try again.',
    retry: 'Reload page',
    noScript: 'Enable JavaScript to open TestFeed.',
};
//# sourceMappingURL=shopify-app-loading.js.map